'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _decorators = require('../utils/propTypes/decorators');

var _DialogConstants = require('./DialogConstants');

var _AbstractModal = require('./internal/AbstractModal');

var _AbstractModal2 = _interopRequireDefault(_AbstractModal);

var _ModalTransition = require('./internal/ModalTransition');

var _ModalTransition2 = _interopRequireDefault(_ModalTransition);

var _UIModalDialog = require('./UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIModal = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(_AbstractModal2.default, _extends({}, props, {
    componentName: 'UIModal',
    Transition: _ModalTransition2.default,
    ref: ref
  }));
});

UIModal.propTypes = _extends({}, _UIModalDialog2.default.propTypes, {
  ModalDialog: (0, _decorators.hidden)(_propTypes2.default.func),
  onCloseComplete: _propTypes2.default.func,
  onCloseStart: _propTypes2.default.func,
  onOpenComplete: _propTypes2.default.func,
  onOpenStart: _propTypes2.default.func,
  use: _propTypes2.default.oneOf(Object.keys(_DialogConstants.MODAL_USE_CLASSES)).isRequired,
  _contextual: _propTypes2.default.bool
});

UIModal.defaultProps = _extends({}, _UIModalDialog2.default.defaultProps, {
  ModalDialog: _UIModalDialog2.default,
  _contextual: false
});

UIModal.displayName = 'UIModal';

exports.default = UIModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIModal.js
// module id = 545
// module chunks = 177